import './LabelTranslated.css';

import React, { forwardRef, useContext, useState } from 'react';
import { fetchAPIDataWhileSettingState, generateClassName } from '../../b2b-common/helpers';
import { IconButton, TextField } from '@mui/material';
import { Edit, Public, PublicOff } from '@mui/icons-material';
import { LoginContext } from '../../../App';
import { getKeyTranslations } from '../../../services/b2b-languages-apiService';
import LabelDetailsModal from '../forms/LabelDetailsModal';
import { removeCurlyBraces } from './helper';

export const setFieldAndLabelField = (object, setObject, field, value) => {
    setObject({
        ...object,
        [field]: value,
        [`${field}_label`]: value,
    });
}

const LabelTranslated = forwardRef(({ field, labelValue, locale, translation, onChange = null, className = null, rowsNumber = null, ...params }, ref) => {
    const { loginData } = useContext(LoginContext);
    const [showTranslation, setShowTranslation] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [labelTranslations, setLabelTranslations] = useState(null);

    const handleVisibilityToggle = () => {
        setShowTranslation(!showTranslation);
    };

    const handleEditLabel = async () => {
        await fetchAllKeyTranslations(removeCurlyBraces(labelValue));
        setOpenModal(true);
    }

    const fetchAllKeyTranslations = async (key) => {
        try {
            const paramsArray = [
                key,
                loginData.accessToken
            ];
            const translations = await fetchAPIDataWhileSettingState(getKeyTranslations, paramsArray, null);
            if (translations.sameLabelTranslations.length === 0) {
                translations.sameLabelTranslations.push({ key: key, content: '', locale: 'es' });
            }
            console.log('Translations:', translations);
            setLabelTranslations(translations);
        } catch (error) {
            console.error(error);
        }
    };

    //console.log('LabelTranslated:', field, labelValue, locale, translation, showTranslation, error);

    return (
        <div className={generateClassName("label-translated", "-container", className)}>
            <div className={generateClassName("label-translated", "-label", className)}>
                <TextField
                    ref={ref}
                    variant="standard"
                    label={field}
                    value={labelValue ? labelValue : ""}
                    readOnly={onChange ? false : true}
                    onChange={onChange ? onChange : () => { }}
                    className={generateClassName("label-translated", "-text-field", className)}
                    {...params}
                />
                <IconButton onClick={handleVisibilityToggle}>
                    {showTranslation ? <PublicOff /> : <Public />}
                </IconButton>
            </div>
            {showTranslation && (
                <div className={generateClassName("label-translated", "-translation", className)}>
                    <TextField
                        variant="outlined"
                        label={locale}
                        value={translation ? translation : ""}
                        readOnly={true}
                        multiline={rowsNumber ? true : false}
                        rows={rowsNumber}
                        className={generateClassName("label-translated", "-text-field-localized", className)}
                        {...params}
                    />
                    <IconButton onClick={handleEditLabel}>
                        <Edit />
                    </IconButton>
                    <LabelDetailsModal
                        open={openModal}
                        labelTranslations={labelTranslations}
                        onClose={() => setOpenModal(false)}
                    />
                </div>
            )}
        </div>
    );
});

LabelTranslated.displayName = 'LabelTranslated';

export default LabelTranslated;